// Thin wrappers that delegate to the single shell-route registry (PR2b.1).
// Names/signatures preserved so existing call sites don't churn.
import { routeIsV2Workspace, routeViewportClamped } from "./shell-routes";

export function isViewportClampedWorkspaceRoute(pathname: string): boolean {
  return routeViewportClamped(pathname);
}

export function isV2WorkspaceRoute(pathname: string): boolean {
  return routeIsV2Workspace(pathname);
}
